import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { IstStudyTeamOrganizationViewModalComponent } from './ist-study-team-organization-view-modal/ist-study-team-organization-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-study-team-organization',
  templateUrl: './ist-study-team-organization.component.html',
  styleUrls: ['./ist-study-team-organization.component.scss']
})
export class IstStudyTeamOrganizationComponent implements OnInit {

  columnDefs;
  operations;
  tempoperation;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  organisationType = [];
  StudyTeamOrganization: UntypedFormGroup;
  permission: string = "";
  IsMultipermission: string = "yes";
  userType: string = "";
  action: Subject<any> = new Subject();
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.rowData = [];
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      const modalRef = this.modalService.open(MessageBoxComponent, {  });
      modalRef.componentInstance.Content={ heading: '', content: { heading: '', description: 'Please save General information details to navigate to Organization Setup', operation: { hasConfirm: false } } }
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });
      return false;
    }

    this.permission = this.commonService.getPagePermission("IST03").toLowerCase();

    this.userType = this.userService.getUserType();
    this.StudyTeamOrganization = new UntypedFormGroup({
      NAME: new UntypedFormControl(null),
      TYPE: new UntypedFormControl(null),
      PhoneNumber: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(100)]),
    });




    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "NAME"
      },
      {
        "headerName": "Organization Type",
        "field": "TYPE"
      },
      {
        "headerName": "Phone number",
        "field": "PhoneNumber"
      }
    ],

      this.IstOrggetMasterData();
    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Name",
          "field": "name",
          "type": "text"
        },
        {
          "label": "Organization Type",
          "field": "type",
          "type": "dropdown",
          "options": this.organisationType,
        },
        {
          "label": "Phone number",
          "field": "phoneNumber",
          "type": "text"
        }
      ]
    }


    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {

      const modalRef = this.modalService.open(MessageBoxComponent, { });
      modalRef.componentInstance.Content= { heading: '', content: { heading: '', description: 'Please save General information details to navigate to other forms ', operation: { hasConfirm: false } } }
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });

      return false;
    }


   
  }
  onAdvanceSearchOperation(searchFiletrs) {

  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const ModelRef=this.modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content= {
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add() {
    if (this.ApplicationID != "") {
      let modalRef = this['self'].modalService.open(IstStudyTeamOrganizationViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'Add',
        content: { id: '', ApplicationID: this.ApplicationID }
      }
      modalRef.result.then(result => {
        this['self'].setSummaryData();
      })
    }
    else {
      this.commonService.ValidationBanner("Please save General Information first");
    }

  }

  view() {
    let modalRef = this['self'].modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummaryData();
    })
  }

  edit() {
    let modalRef = this['self'].modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummaryData();
    })
  }

  
  delete(service) {

    let id = this['self'].selectedRow['ID'];
    var Name = this['self'].selectedRow['NAME'];
    if (this['self'].selectedRow["CREATED_BY"] != "Admin") {

      const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false
      })
      modalRef.componentInstance.Content= { heading: 'Delete', content: {custommessage: 'The Organization ' + Name + ' will be deleted. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "No" }}
      modalRef.result.then(result => {
        if (result == "okclick") {
          service.DeleteRecord('api/ISTOrganization/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              this['self'].commonService.SuccessBanner(summary["Message"]);
              this['self'].setSummaryData();
            }
            else {
              this['self'].commonService.ValidationBanner(summary["Message"]);
            }
          });
        }
      });
    }
    else {
      this['self'].commonService.ValidationBanner("Default Record can't be Deleted");
    }

  }
  IstOrggetMasterData() {
    this.organisationType = [];
    this.summaryService.getSummaryData('api/ISTOrganization/GetMasterDataSearch?ApplicationID=' + this.ApplicationID).subscribe(summary => {
      this.organisationType = summary["MasterData1"];
      this.organisationType = [{ label: "Select", value: "", checked: true }].concat(this.organisationType);
      if (summary["MasterData3"] != null && summary["MasterData3"] != undefined) {
   
        this.IsMultipermission = summary["MasterData3"][0].value;
      }
      this.setSummaryData();
    });
  }
  setSummaryData() {
    this.SearchClear();
    if (this.ApplicationID != "" && this.ApplicationID != undefined) {
      this.summaryService.getSummaryData('api/ISTOrganization/GetSummaryData?ApplicationID=' + this.ApplicationID).subscribe(summary => {
        this.rowData = this.setOperations(summary);
      });
    }
    else {
      this.rowData = [];
    }
  }

  fetchSearchData(searchObject) {
    this.summaryService.fetchSearchData('api/ISTOrganization/GetSummarySearchData', searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    return this.operations;
  }


  setOperations(RawData: any): any {
    let tempoperations = [
      {
        "name": "View",
        "id": "view"
      },
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];
    if (this.IsMultipermission === 'yes' && this.permission == "new") {
      tempoperations.push({
        "name": "Add new",
        "id": "add"
      });
    }

    let tempoperations2 = [
      {
        "name": "View",
        "id": "view"
      }
    ];
    if (this.IsMultipermission === 'yes' && this.permission == "new") {
      tempoperations2.push({
        "name": "Add new",
        "id": "add"
      });
    }

    RawData.forEach(element => {
      if (element.CREATED_BY === "Admin" || this.permission === "view") {

        element["Operations"] = this.setDef(tempoperations2);
      }
      else {

        element["Operations"] = this.setDef(tempoperations);
      }
    });
    return RawData;
  }
  //// Advace search Functions
  SearchClear() {
    this.StudyTeamOrganization.reset();
  }
  ValidateForm() {

    var err: any = [];
    if (this.StudyTeamOrganization.valid) {
      if (
        !this.StudyTeamOrganization.controls["NAME"].value &&
        !this.StudyTeamOrganization.controls["TYPE"].value &&
        !this.StudyTeamOrganization.controls["PhoneNumber"].value
      ) {
        err.push("Please enter atleast one criteria to perform search");
        this.commonService.ValidationBanner(err);
        return false;
      }
    }
    return true;
  }

  AdvanceSearch() {
    if (this.ValidateForm()) {
      var formData = this.StudyTeamOrganization.value;
      formData["ApplicationID"] = this.ApplicationID;
      this.fetchSearchData(formData);
    }
  }
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }

}
